import { render } from "./SectionsDetailSubsection.vue?vue&type=template&id=0ba68579"
import script from "./SectionsDetailSubsection.vue?vue&type=script&lang=js"
export * from "./SectionsDetailSubsection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__